export class PermissionsController {
    constructor(XrayPermissionsDao, $scope, JFrogGridFactory, UsersDao, JFrogModal, commonGridColumns, BruteForceDao,
                $timeout,
                JFrogNotifications, uiGridConstants, XRayUIPermissions, $interval) {
        this.BruteForceDao = BruteForceDao;
        this.$scope = $scope;
        this.$interval = $interval;
        this.jfrogGridFactory = JFrogGridFactory;
        this.JFrogNotifications = JFrogNotifications;
        this.XRayUIPermissions = XRayUIPermissions;
        this.$timeout = $timeout;
        this.uiGridConstants = uiGridConstants;
        this.usersDao = UsersDao;
        this.permissionsDao = XrayPermissionsDao;
        this.modal = JFrogModal;
        this.commonGridColumns = commonGridColumns;
        $scope.$parent.Settings.showButtons = false;
        $scope.$parent.Settings.currentSubController = this;
        this._createGrid();
        this._getRules();
        $scope.$on('$destroy', () => {
            this.stopInterval();
        });
        if (!this.XRayUIPermissions.isActivated()) {
            this.dataMigrationRunning = true;
            this._getMigrationData();

        }

    }

    _createGrid() {
        this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getColumns())
            .setButtons(this._getActions());
    }

    _getRules() {

        this.permissionsDao.getRules().$promise.then((response) => {
	        _.forEach(response, (val, key) => {
		        if (val.users) {
			        val.users = val.users.sort();
		        }
		        if (val.groups) {
			        val.groups = val.groups.sort();
		        }

	        });

            this.gridOptions.setGridData(response);
        }).catch(() => this.gridOptions.setGridData([]));

    }

    deleteRule(row) {
        this.modal.confirm(`Are you sure you want to delete rule "${row.name}"?`)
            .then(() => {
                this.permissionsDao.deleteRule({}, {permissionName: row.name}).$promise.then(() => {
                    this._getRules();
                }).catch(() => this.gridOptions.setGridData([]));
            });
    }


    _getColumns() {
        //listableColumn: function(listModel,rowNameModel,displayModel,alwaysShow,testIdPrefix=null)
        return [
            {
                name: 'name',
                displayName: 'Permission Name',
                field: 'name',
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="settings.permissions.edit({permissionName: row.entity.name})"><a href="">{{row.entity.name}}</a></div>',
                width: '25%'
            },
            {
                name: 'resources',
                displayName: 'Resources',
                cellTemplate: `<div ng-if="row.entity.resources && row.entity.type !=='global'" class="ui-grid-cell-contents "> <span ng-if="row.entity.resources.builds" > {{row.entity.resources.builds}}   <ng-pluralize count="row.entity.resources.builds"
                      when="{'1':'Build',
                              'other' : 'Builds'}">
        </ng-pluralize></span><span ng-if="row.entity.resources.builds && row.entity.resources.repositories" > | </span> <span ng-if="row.entity.resources.repositories" > {{row.entity.resources.repositories}} <ng-pluralize count="row.entity.resources.repositories"
                      when="{'1':'Repository',
                              'other' : 'Repositories'}">
        </ng-pluralize></span><a style="float:right" ng-click="grid.appScope.Permissions.showResources(row.entity.name);" class="show-all-link" ng-if="row.entity.resources.builds || row.entity.resources.repositories">See All</a></div><div class="ui-grid-cell-contents" ng-if="row.entity.type ==='global'" > All  </div>`,
                field: 'email',
                width: '25%'
            },
            {
                name: 'groups',
                displayName: 'Groups',
                field: 'groups',
                cellTemplate: this.commonGridColumns.listableColumn('row.entity.groups', 'row.entity.name', null,
                    false),
                width: '25%'
            },
            {
                name: 'users',
                field: 'users',
                displayName: 'Users',
                cellTemplate: this.commonGridColumns.listableColumn('row.entity.users', 'row.entity.name', null, false),
                width: '25%'
            }
        ];
    }

    showResources(ruleName) {
        let modalScope = this.$scope.$new();
        this.permissionsDao.getOneInstance({}, {name: ruleName}).$promise.then((data) => {
            this.listGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                .setRowTemplate('default')
                .setColumns(this._getListColumns())
                .setRowsPerPage(8)
                .setGridData(data.resources);
            modalScope.modalTitle = ruleName + ' Resources';
            modalScope.gridOptions = this.listGridOptions;
            this.modal.launchModal('show_list_grid_modal', modalScope).result.then(() => {
            });
        });
    }

    _getListColumns() {
        return [
            {
                displayName: 'Instance',
                field: 'name',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.name.split('::')[0]}}</div>`,
                width: '33%'
            },
            {

                displayName: 'Resource',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.name.split('::')[1] }}</div>`,
                field: 'name',
                width: '34%'
            },
            {
                name: 'type',
                displayName: 'Type',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.type | capitalizeFirst }}</div>`,
                field: 'type',
                sort: {
                    direction: this.uiGridConstants.ASC
                },
                width: '33%'
            }
        ];
    }

    _getActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteRule(row),
                visibleWhen: (row) => {

                    return row.name !== 'Admins';

                }
            }

        ];
    }


    _getMigrationData() {
        this.permissionsDao.getMigrationStatus({$no_spinner: true}).$promise.then((data) => {


            let status = data.status;

            if (status == 'finished') {
                this.migrationCompleted = true;
                this.barWidth = 100;
                this.migrationTitle = 'All Done!';

            } else if (status == 'pending') {
                this.migrationTitle = 'Almost There!';
                this.migrationPending = true;
                data = 'pending';
                this.setProgress(data);

            } else {

                this.migrationTitle = 'Almost There!';
                this.migrationPending = false;
                if (data.total_artifacts) {
                    data = {total: data.total_artifacts, current: data.finished_artifacts};
                    this.setProgress(data);
                }
            }

            if (!this.intervalPromise && !this.migrationCompleted) {
                this.startInterval();
            }

            this.stopInterval();
        });
    }

    startInterval() {
        this.intervalPromise = this.$interval(() => {
            this._getMigrationData();
        }, 5000);
    }

    stopInterval() {
        if (this.migrationCompleted) {
            this.$interval.cancel(this.intervalPromise);
            this.intervalPromise = null;
        }
    }

    setProgress(data) {
        if (data !== 'pending') {
            this.currentTotal = data.total;
            this.currentIndex = data.current;

            let current = parseInt(this.currentIndex);
            let total = parseInt(this.currentTotal);
            this.barWidth = Math.floor((current / total) * 100);

            if (this.barWidth < 1) {
                this.barWidth = 1;
            }
            if (this.currentTotal <= this.currentIndex) {
                this.migrationFinished = true;
                this.barWidth = 100;
                this.migrationCompleted = true;
            }
        } else {

            this.barWidth = 0;
        }

    }

    activatePermission() {

        this.permissionsDao.activate().$promise.then((data) => {
            this.dataMigrationRunning = false;
            this.XRayUIPermissions.activePermission();

        });
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/permissions/permissions.controller.js